/* eslint-disable import/no-cycle */
import React from 'react';
import DOMPurify from 'dompurify';

import Message from '../Message';
import findLinkOrEmail from '../../utils/findLinkOrEmail.js';
import { regLink } from '../../messageHelpers';

const regReplace = /@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/gi;

class TextMessage extends Message {
  constructor(messageParams, serverUrl) {
    super(messageParams);

    this.serverUrl = serverUrl;
    this.parse(serverUrl);
    this.renderText = this.renderText.bind(this);
  }

  parse(serverUrl) {
    if (this.text.match('<img') && this.text.match('Smiley:')) {
      this.text = this.text.replace(/\{visitor-server-url\}/g, serverUrl);
      this.subtype = 'smiley';
    }

    if (this.text.match(regLink) || this.text.replace(/mailto:/gi, ' ').match(regReplace)) {
      const link = findLinkOrEmail(this.text, regLink);
      this.text = link.text;
      this.subtype = link.subtype ? link.subtype : this.subtype;
    }
  }

  renderText(TextNode) {
    /* узкое место, т.к при тайпинге срабатывает рендеринг всех сообщений */
    // TODO: при отправке сообщения рендер старых срабатывает 3 раза, разобраться почему
    // 1 - ???
    // 2 - добавоение фейкового сообщения
    // 3 - когда сообщение пришло с сервера
    let __html = this.text.replace(/<img\b[^>]*>/gi, (match) => {
      /* Попробуем найти значение src (в любом регистре, с или без кавычек) */
      const srcMatch = match.match(/\bsrc\s*=\s*(?:"([^"]*)"|'([^']*)'|([^ \t\n\r\f>]+))/i);
      const src = srcMatch?.[1] || srcMatch?.[2] || srcMatch?.[3];
      /* Проверка, что src есть и начинается с допустимого URL */
      const isAllowedSrc = src && src.startsWith(this.serverUrl)
      /* Если нет src или он запрещённый — экранируем <img */
      if (!isAllowedSrc) {
        return match.replace(/<img/i, '&lt;img');
      }
      return match;
    });
    __html = DOMPurify.sanitize(__html, {
      ADD_ATTR: ['target'], /* для ссылок */
    })
    return (
      <TextNode
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html }}
      />
    );
  }
}

export default TextMessage;
